//@ts-nocheck

import styled, { css } from "styled-components";
import { FInter, FlexBox } from "@brg/ui";
import ResizedImageEnhanced from "../ResizedImageEnhanced";
import { NeutralLink } from "../link/styles";
import { LikesBoxContainer } from "../likesBox/Styles";
import { LayoutConst } from "../../../core";
import ArrowBack from "./ArrowBack";
import { Circle, Count } from "./NotificationBellIcon";
import { RectangularButtonHollow } from 'shared/components/buttons';
import { DEFAULT_DROPDOWN_HEIGHT } from "./const/const";
import Z_INDEX from "shared/constants/Layers";

export const NotificationDropdownWrapper = styled.div<{ scroll?: boolean, height: number }>`
  #notification-dropdown-main {

    ${({ height }) => height && css`
      max-height: ${height || DEFAULT_DROPDOWN_HEIGHT}px;
    `};
    ${({ scroll }) => !scroll && css`
      overflow-y: hidden !important;
    `};

    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);

    ::-webkit-scrollbar {
      width: 3px !important;
      height: 2px !important;
    }
    ::-webkit-scrollbar-thumb {
      background: rgba(144, 144, 144, 1) !important;
    }
    ::-webkit-scrollbar-track {
      background: rgba(231, 231, 231, 1) !important;
    }

  }

`;

export const Wrapper = styled.div`
  & > div > div:last-child {
    top: 40px;
   @media (max-width: ${LayoutConst.screen.l_16}px) {
      top: 37px;
    })
  }
`
export const Header = styled(FlexBox)<{isCGRAVE?: boolean}>`
  padding: 16px 16px 8px;
  justify-content: center;
  background: ${({theme, isCGRAVE}) => isCGRAVE ? '#2C2C2B' : theme.notifications.background};
  color: ${({isCGRAVE}) => isCGRAVE ? '#A3A3A3' : ''};
  position: sticky;
  z-index: 10;
  top: 0;
`

export const Avatar = styled(ResizedImageEnhanced)`
  width: 36px;
  height: 36px;
  border-radius: 3px;
  flex-shrink: 0;
  overflow: hidden;
`

export const Name = styled.div`
  color: ${({theme}) => theme.notifications.name.color};
  font-size: 13px;
  line-height: 16px;
  font-weight: 600;
`;

export const AvatarWrapper = styled(FlexBox)`
  width: 36px;
  height: 36px;
  border-radius: 3px;
  flex-shrink: 0;
  overflow: hidden;
`

export const NotificationHeader = styled(FlexBox)`
  align-items: flex-start;
`

export const Title = styled(FInter.TextBold)<{isCGRAVE?: boolean}>`
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  color: ${({isCGRAVE}) => isCGRAVE ? '#A3A3A3 !important' : ''};
`

export const NotificationMessage = styled(FInter.SmallText)`
  font-size: 13px;
  line-height: 16px;
`

export const InitiatorName = styled.span`
  font-weight: 600;
`

export const ProjectInfo = styled(FlexBox)`
  padding: 8px;
  max-width: 280px;
  min-width: 280px;
  width: 100%;
  border-radius: 3px;
  
  @media (max-width: 375px){
    min-width: auto;
  }
`

export const ProjectPoster = styled(ResizedImageEnhanced)`
  height: 65px;
  width: 46px;
  flex-shrink: 0;
`

export const ProjectTitle = styled(FInter.SmallText)`
  font-size: 13px;
  line-height: 16px;
  font-weight: 600 !important;
`;


export const SimpleTitle = styled(ProjectTitle)`
  font-weight: 400 !important;
  
  a {
    color: ${p => p.theme.notifications.link};
    font-weight: 600 !important;
  }
  span {
    color: ${p => p.theme.notifications.link};
    font-weight: 600 !important;
  }
`;

export const DateText = styled(FInter.SmallText)`
  font-size: 10px;
  line-height: 10px;
  color: ${({theme}) => theme.notifications.likes} !important;
  font-weight: 400;
  margin-left: 10px;
  text-align: right;
`



export const NotificationRoot = styled(FlexBox)<{ isRead?: boolean, isCGRAVE?: boolean, isSuperPuper?: boolean, isImportantNots?: boolean, isNew?: boolean, stripeColor?: string }>`
  flex-direction: column;
  position: relative;
  padding: 8px 16px;
  // border-bottom: 1px solid #E7E7E7;
  cursor: pointer;
  background: ${({theme, isCGRAVE}) => isCGRAVE ? '#2C2C2B' : theme.notifications.background};
  span {
    color: ${({isCGRAVE}) => isCGRAVE ? '#BFBFBF !important' : ''};
  }

  ${({ isNew, isImportantNots, isHSEDesign, isSuperPuper, stripeColor }) => isNew && css`
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 2px;
      background-color: ${({stripeColor}) => stripeColor? stripeColor : ({isHSEDesign}) => isHSEDesign ? "#609AF0" : ({isImportantNots, theme}) => isSuperPuper ? '#FF0000' : isImportantNots ? 'blue' : theme.navigationBar.backgroundDirtyColor || 'red'};
      content: '';
      display: block;
    }
  `};

  ${ProjectInfo} {
    background: ${({isRead, theme}) => isRead
            ? theme.notifications.projectBackground
            : theme.notifications.projectBackgroundUnread};
  }

  &:hover {
    background: ${({ theme }) => theme.notifications.backgroundHover} !important;
    transition: background 0.2s;
    span {
      color: ${({isCGRAVE}) => isCGRAVE ? '#A3A3A3 !important' : ''};
    }
  }
  
  &:last-child {
    padding-bottom: 16px;
    @media (max-width: ${LayoutConst.screen.sm}px) {
      padding-bottom: 80px;
    })
  }
`

export const Link = styled(NeutralLink)`
  width: initial;
  display: inline-flex;
  min-height: 100%;
`

export const BottomGroup = styled(FlexBox)`
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;

  ${Link} {
    width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    flex-direction: column;
    ${ProjectInfo} {
      max-width: 100%;
    }
    
    ${DateText} {
      margin-top: 8px;
    }
  })
`

export const LikesWrapper = styled(FlexBox)`
  * {
    color: ${({theme}) => theme.notifications.likes} !important;
    font-size: 10px;
    line-height: 10px;
    font-weight: 500;
  }
  
  svg {
    height: 14px;
    width: 14px;
  }
  
  ${LikesBoxContainer} {
    div:nth-child(2) {
      margin-left: 4px;
    }
  }
`

export const NotificationListWrapper = styled(FlexBox)<{isCGRAVE?: boolean}>`
  position: relative;
  background: ${({ theme, isCGRAVE}) => isCGRAVE ? '#2C2C2B' : theme.notifications.background};

  .notification-inf-scroll, .notification-inf-scroll_achirved {
    ::-webkit-scrollbar {
      width: 3px !important;
      height: 2px !important;
    }
    ::-webkit-scrollbar-thumb {
      background: rgba(144, 144, 144, 1) !important;
    }
    ::-webkit-scrollbar-track {
      background: rgba(231, 231, 231, 1) !important;
    }
  }

  ${NotificationRoot}:not(:last-child) {
    border-bottom: 1px solid ${({theme}) => theme.notifications.borderColor};
  }

  ${NotificationRoot}:last-child {
    padding-bottom: 24px;
  }

  ::-webkit-scrollbar {
    height: 2px;
  }
  ::-webkit-scrollbar-thumb {
    background: tomato;
  }
  ::-webkit-scrollbar-track {
    background: tomato;
  }
  
  ${FInter.SmallText}, ${FInter.TextBold} {
    color: ${({theme}) => theme.notifications.textColor}
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    height: 100%;
    width: 100%;
  })

`;

export const ScrollWrapper = styled(FlexBox)`
  height: 100%;
  display: block;

  @media (max-width: ${LayoutConst.screen.sm}px) {
    overflow-y: overlay;
  }
`

export const BackButton = styled(ArrowBack)`
  display: none;
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);

  @media (max-width: ${LayoutConst.screen.s}px) {
    display: initial;
  })
`

export const Placeholder = styled(FlexBox)`
  height: 128px;
  width: 100%;
  background: ${({ theme}) => theme.notifications.background};
  align-items: center;
  justify-content: center;
  padding: 8px 16px 16px;

  @media (max-width: ${LayoutConst.screen.sm}px) {
    height: calc(100% - 50px);
  })
`

export const PlaceholderText = styled(FInter.SmallText)`
  color: ${({theme}) => theme.notifications.textColor} !important;
  font-size: 13px;
  line-height: 16px;
  font-weight: 400;
`

export const TabsWrapper = styled(FlexBox)<{isCGRAVE?: boolean}>`
  padding: 4px 16px;
  background: ${({ theme, isCGRAVE}) => isCGRAVE ? '#2C2C2B' : theme.notifications.background};
  align-items: center;
  flex-wrap: nowrap;
  overflow: visible;
`

export const TabMenuButton = styled(FlexBox)<{isCGRAVE?: boolean, active?: boolean}>`
  cursor: pointer;
  flex-shrink: 0;
  padding: 0 2px;
  align-items: center;
  justify-content: center;
  align-self: center;
  position: relative;
  z-index: 20;
  overflow: visible;

  color: ${({ active, theme, isCGRAVE }) =>
    active
      ? (isCGRAVE ? '#FEFEFE' : theme.notifications.textColor)
      : (isCGRAVE ? '#A3A3A3' : theme.notifications.likes)};

  svg path {
    fill: currentColor;
  }

  &:hover {
    color: ${({ theme, isCGRAVE }) => isCGRAVE ? '#FEFEFE' : theme.notifications.textColor};
  }
`

export const TabText = styled(FInter.TextBold)`
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
`
export const Tab = styled(FlexBox)<{ active?: boolean, isCGRAVE?: boolean}>`
  cursor: pointer;
  align-items: center;
  ${TabText} {
    color: ${({ active, theme, isCGRAVE }) => active ? theme.notifications.textColor : isCGRAVE ? '#A3A3A3' : theme.notifications.likes };
  }
  ${Circle} {
    position: relative;
  }
`

export const StickyWrapper = styled.div<{isCGRAVE?: boolean}>`
  width: 100%;
  position: sticky;
  z-index: 20;
  top: 0;
    background: ${({ theme, isCGRAVE}) => isCGRAVE ? '#2C2C2B' : theme.notifications.background};
  margin-bottom: 12px;
`

export const ArchiveDropdownWrapper = styled.div`
  position: relative;
  z-index: 30;

  .dropdown-element-popup.dropdown-show {
    z-index: ${Z_INDEX.navbar_dropdown + 1};
  }
`

export const ButtonsWrapper = styled(FlexBox)`
  padding: 8px 16px;
  margin-bottom: 4px;
  justify-content: space-between;
`

export const Button = styled(RectangularButtonHollow)<{isCGRAVE?: boolean}>`
  width: calc(50% - 8px);
  font-weight: 400 !important;
  font-size: 11px !important;
  line-height: 13px !important;
  padding: 4px !important;
  height: 21px !important;
  border-color: #909090;
  color: ${({ isCGRAVE }) => isCGRAVE ? '#A3A3A3' : ''};
`

export const DivLink = styled.div``

export const NotificationListContainer = styled.div`
  width: 400px;
  max-width: 400px;
  min-width: 400px;
  height: auto;
  // position: absolute;
  position: fixed;
  top: var(--brg-eco-search-top, 60px);
  right: 32px;
  z-index: var(--brg-eco-search-z, ${Z_INDEX.navbar_dropdown});

  @media (max-width: 1199px) {
    top: var(--brg-eco-search-top, 48px);
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    right: 16px;
    top: var(--brg-eco-search-top, 48px);
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    right: 10px;
  }
`;//@ts-nocheck

import styled, { css } from "styled-components";
import { FInter, FlexBox } from "@brg/ui";
import ResizedImageEnhanced from "../ResizedImageEnhanced";
import { NeutralLink } from "../link/styles";
import { LikesBoxContainer } from "../likesBox/Styles";
import { LayoutConst } from "../../../core";
import ArrowBack from "./ArrowBack";
import { Circle, Count } from "./NotificationBellIcon";
import { RectangularButtonHollow } from 'shared/components/buttons';
import { DEFAULT_DROPDOWN_HEIGHT } from "./const/const";
import Z_INDEX from "shared/constants/Layers";

export const NotificationDropdownWrapper = styled.div<{ scroll?: boolean, height: number }>`
  #notification-dropdown-main {

    ${({ height }) => height && css`
      max-height: ${height || DEFAULT_DROPDOWN_HEIGHT}px;
    `};
    ${({ scroll }) => !scroll && css`
      overflow-y: hidden !important;
    `};

    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);

    ::-webkit-scrollbar {
      width: 3px !important;
      height: 2px !important;
    }
    ::-webkit-scrollbar-thumb {
      background: rgba(144, 144, 144, 1) !important;
    }
    ::-webkit-scrollbar-track {
      background: rgba(231, 231, 231, 1) !important;
    }

  }

`;

export const Wrapper = styled.div`
  & > div > div:last-child {
    top: 40px;
   @media (max-width: ${LayoutConst.screen.l_16}px) {
      top: 37px;
    })
  }
`
export const Header = styled(FlexBox)<{isCGRAVE?: boolean}>`
  padding: 16px 16px 8px;
  justify-content: center;
  background: ${({theme, isCGRAVE}) => isCGRAVE ? '#2C2C2B' : theme.notifications.background};
  color: ${({isCGRAVE}) => isCGRAVE ? '#A3A3A3' : ''};
  position: sticky;
  z-index: 10;
  top: 0;
`

export const Avatar = styled(ResizedImageEnhanced)`
  width: 36px;
  height: 36px;
  border-radius: 3px;
  flex-shrink: 0;
  overflow: hidden;
`

export const Name = styled.div`
  color: ${({theme}) => theme.notifications.name.color};
  font-size: 13px;
  line-height: 16px;
  font-weight: 600;
`;

export const AvatarWrapper = styled(FlexBox)`
  width: 36px;
  height: 36px;
  border-radius: 3px;
  flex-shrink: 0;
  overflow: hidden;
`

export const NotificationHeader = styled(FlexBox)`
  align-items: flex-start;
`

export const Title = styled(FInter.TextBold)<{isCGRAVE?: boolean}>`
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  color: ${({isCGRAVE}) => isCGRAVE ? '#A3A3A3 !important' : ''};
`

export const NotificationMessage = styled(FInter.SmallText)`
  font-size: 13px;
  line-height: 16px;
`

export const InitiatorName = styled.span`
  font-weight: 600;
`

export const ProjectInfo = styled(FlexBox)`
  padding: 8px;
  max-width: 280px;
  min-width: 280px;
  width: 100%;
  border-radius: 3px;
  
  @media (max-width: 375px){
    min-width: auto;
  }
`

export const ProjectPoster = styled(ResizedImageEnhanced)`
  height: 65px;
  width: 46px;
  flex-shrink: 0;
`

export const ProjectTitle = styled(FInter.SmallText)`
  font-size: 13px;
  line-height: 16px;
  font-weight: 600 !important;
`;


export const SimpleTitle = styled(ProjectTitle)`
  font-weight: 400 !important;
  
  a {
    color: ${p => p.theme.notifications.link};
    font-weight: 600 !important;
  }
  span {
    color: ${p => p.theme.notifications.link};
    font-weight: 600 !important;
  }
`;

export const DateText = styled(FInter.SmallText)`
  font-size: 10px;
  line-height: 10px;
  color: ${({theme}) => theme.notifications.likes} !important;
  font-weight: 400;
  margin-left: 10px;
  text-align: right;
`



export const NotificationRoot = styled(FlexBox)<{ isRead?: boolean, isCGRAVE?: boolean, isSuperPuper?: boolean, isImportantNots?: boolean, isNew?: boolean, stripeColor?: string }>`
  flex-direction: column;
  position: relative;
  padding: 8px 16px;
  // border-bottom: 1px solid #E7E7E7;
  cursor: pointer;
  background: ${({theme, isCGRAVE}) => isCGRAVE ? '#2C2C2B' : theme.notifications.background};
  span {
    color: ${({isCGRAVE}) => isCGRAVE ? '#BFBFBF !important' : ''};
  }

  ${({ isNew, isImportantNots, isHSEDesign, isSuperPuper, stripeColor }) => isNew && css`
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 2px;
      background-color: ${({stripeColor}) => stripeColor? stripeColor : ({isHSEDesign}) => isHSEDesign ? "#609AF0" : ({isImportantNots, theme}) => isSuperPuper ? '#FF0000' : isImportantNots ? 'blue' : theme.navigationBar.backgroundDirtyColor || 'red'};
      content: '';
      display: block;
    }
  `};

  ${ProjectInfo} {
    background: ${({isRead, theme}) => isRead
            ? theme.notifications.projectBackground
            : theme.notifications.projectBackgroundUnread};
  }

  &:hover {
    background: ${({ theme }) => theme.notifications.backgroundHover} !important;
    transition: background 0.2s;
    span {
      color: ${({isCGRAVE}) => isCGRAVE ? '#A3A3A3 !important' : ''};
    }
  }
  
  &:last-child {
    padding-bottom: 16px;
    @media (max-width: ${LayoutConst.screen.sm}px) {
      padding-bottom: 80px;
    })
  }
`

export const Link = styled(NeutralLink)`
  width: initial;
  display: inline-flex;
  min-height: 100%;
`

export const BottomGroup = styled(FlexBox)`
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;

  ${Link} {
    width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    flex-direction: column;
    ${ProjectInfo} {
      max-width: 100%;
    }
    
    ${DateText} {
      margin-top: 8px;
    }
  })
`

export const LikesWrapper = styled(FlexBox)`
  * {
    color: ${({theme}) => theme.notifications.likes} !important;
    font-size: 10px;
    line-height: 10px;
    font-weight: 500;
  }
  
  svg {
    height: 14px;
    width: 14px;
  }
  
  ${LikesBoxContainer} {
    div:nth-child(2) {
      margin-left: 4px;
    }
  }
`

export const NotificationListWrapper = styled(FlexBox)<{isCGRAVE?: boolean}>`
  position: relative;
  background: ${({ theme, isCGRAVE}) => isCGRAVE ? '#2C2C2B' : theme.notifications.background};

  .notification-inf-scroll, .notification-inf-scroll_achirved {
    ::-webkit-scrollbar {
      width: 3px !important;
      height: 2px !important;
    }
    ::-webkit-scrollbar-thumb {
      background: rgba(144, 144, 144, 1) !important;
    }
    ::-webkit-scrollbar-track {
      background: rgba(231, 231, 231, 1) !important;
    }
  }

  ${NotificationRoot}:not(:last-child) {
    border-bottom: 1px solid ${({theme}) => theme.notifications.borderColor};
  }

  ${NotificationRoot}:last-child {
    padding-bottom: 24px;
  }

  ::-webkit-scrollbar {
    height: 2px;
  }
  ::-webkit-scrollbar-thumb {
    background: tomato;
  }
  ::-webkit-scrollbar-track {
    background: tomato;
  }
  
  ${FInter.SmallText}, ${FInter.TextBold} {
    color: ${({theme}) => theme.notifications.textColor}
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    height: 100%;
    width: 100%;
  })

`;

export const ScrollWrapper = styled(FlexBox)`
  height: 100%;
  display: block;

  @media (max-width: ${LayoutConst.screen.sm}px) {
    overflow-y: overlay;
  }
`

export const BackButton = styled(ArrowBack)`
  display: none;
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);

  @media (max-width: ${LayoutConst.screen.s}px) {
    display: initial;
  })
`

export const Placeholder = styled(FlexBox)`
  height: 128px;
  width: 100%;
  background: ${({ theme}) => theme.notifications.background};
  align-items: center;
  justify-content: center;
  padding: 8px 16px 16px;

  @media (max-width: ${LayoutConst.screen.sm}px) {
    height: calc(100% - 50px);
  })
`

export const PlaceholderText = styled(FInter.SmallText)`
  color: ${({theme}) => theme.notifications.textColor} !important;
  font-size: 13px;
  line-height: 16px;
  font-weight: 400;
`

export const TabsWrapper = styled(FlexBox)<{isCGRAVE?: boolean}>`
  padding: 4px 16px;
  background: ${({ theme, isCGRAVE}) => isCGRAVE ? '#2C2C2B' : theme.notifications.background};
  align-items: center;
  flex-wrap: nowrap;
  overflow: visible;
`

export const TabMenuButton = styled(FlexBox)<{isCGRAVE?: boolean, active?: boolean}>`
  cursor: pointer;
  flex-shrink: 0;
  padding: 0 2px;
  align-items: center;
  justify-content: center;
  align-self: center;
  position: relative;
  z-index: 20;
  overflow: visible;

  color: ${({ active, theme, isCGRAVE }) =>
    active
      ? (isCGRAVE ? '#FEFEFE' : theme.notifications.textColor)
      : (isCGRAVE ? '#A3A3A3' : theme.notifications.likes)};

  svg path {
    fill: currentColor;
  }

  &:hover {
    color: ${({ theme, isCGRAVE }) => isCGRAVE ? '#FEFEFE' : theme.notifications.textColor};
  }
`

export const TabText = styled(FInter.TextBold)`
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
`
export const Tab = styled(FlexBox)<{ active?: boolean, isCGRAVE?: boolean}>`
  cursor: pointer;
  align-items: center;
  ${TabText} {
    color: ${({ active, theme, isCGRAVE }) => active ? theme.notifications.textColor : isCGRAVE ? '#A3A3A3' : theme.notifications.likes };
  }
  ${Circle} {
    position: relative;
  }
`

export const StickyWrapper = styled.div<{isCGRAVE?: boolean}>`
  width: 100%;
  position: sticky;
  z-index: 20;
  top: 0;
    background: ${({ theme, isCGRAVE}) => isCGRAVE ? '#2C2C2B' : theme.notifications.background};
  margin-bottom: 12px;
`

export const ArchiveDropdownWrapper = styled.div`
  position: relative;
  z-index: 30;

  .dropdown-element-popup.dropdown-show {
    z-index: ${Z_INDEX.navbar_dropdown + 1};
  }
`

export const ButtonsWrapper = styled(FlexBox)`
  padding: 8px 16px;
  margin-bottom: 4px;
  justify-content: space-between;
`

export const Button = styled(RectangularButtonHollow)<{isCGRAVE?: boolean}>`
  width: calc(50% - 8px);
  font-weight: 400 !important;
  font-size: 11px !important;
  line-height: 13px !important;
  padding: 4px !important;
  height: 21px !important;
  border-color: #909090;
  color: ${({ isCGRAVE }) => isCGRAVE ? '#A3A3A3' : ''};
`

export const DivLink = styled.div``

export const NotificationListContainer = styled.div`
  width: 400px;
  max-width: 400px;
  min-width: 400px;
  height: auto;
  // position: absolute;
  position: fixed;
  top: var(--brg-eco-search-top, 60px);
  right: 32px;
  z-index: var(--brg-eco-search-z, ${Z_INDEX.navbar_dropdown});

  @media (max-width: 1199px) {
    top: var(--brg-eco-search-top, 48px);
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    right: 16px;
    top: var(--brg-eco-search-top, 48px);
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    right: 10px;
  }
`;